import { CardGetExtension, ICardGetExtensionContext } from 'tessa/cards/extensions';
import { DotNetType, createTypedField } from 'tessa/platform';
import { UIContext, tryGetFromInfo } from 'tessa/ui';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { ITessaView } from 'tessa/views';

export class CdPartnerKCKGetExtension extends CardGetExtension {

  public beforeRequest(context: ICardGetExtensionContext) {
    if (context == null) return;

    // TODO откладывается до версии 3.3
    let viewContext = UIContext.current.viewContext;

    let view: ITessaView;
    if (viewContext != null &&
        (view = viewContext.view!) != null &&
        (
            view.metadata.alias === "PkKCKPartners" ||
            view.metadata.alias === "PkKCKPartners_Administrate"
        ) &&
        !!viewContext.selectedRow) {
        let externalID = viewContext.selectedRow!.get("PartnerExternalID");

        context.request.cardTypeId = CdCardTypes.PkKCKPartnerTypeID;
        context.request.info["ExternalID"] = createTypedField(externalID, DotNetType.Int64);
        return;
    }

    let cardContext = UIContext.current.cardEditor;
    if (UIContext.current.parent == null &&
       cardContext != null &&
       cardContext.cardModel != null &&
       cardContext.cardModel.cardType.id === CdCardTypes.PkKCKPartnerTypeID) {
        let externalID = tryGetFromInfo(cardContext.cardModel.card.info, "ExternalID");

        context.request.cardTypeId = CdCardTypes.PkKCKPartnerTypeID;

        context.request.info["ExternalID"] = createTypedField(externalID, DotNetType.Int64);
        return;
    }
  }

}